import { CardSuit } from "../card/Card";
import { PopupBiddingChoiceType } from "../popup/PopupBiddingTakeSuit";
import { TrumpSuit } from "../state/TableStateMachine";

export function TrumpSuitToPopupBiddingChoiceType(cardSuit: TrumpSuit): PopupBiddingChoiceType
{
    switch (cardSuit) {
        case TrumpSuit.CLUBS:
            return PopupBiddingChoiceType.CLUBS;
        case TrumpSuit.DIAMONDS:
            return PopupBiddingChoiceType.DIAMONDS;
        case TrumpSuit.HEARTS:
            return PopupBiddingChoiceType.HEARTS;
        case TrumpSuit.SPADES:
            return PopupBiddingChoiceType.SPADES;
        case TrumpSuit.NOTRUMPS:
            return PopupBiddingChoiceType.NOTRUMPS;
        case TrumpSuit.ALLTRUMPS:
            return PopupBiddingChoiceType.ALLTRUMPS;
    }
    return PopupBiddingChoiceType.PASS;
}